/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { forwardRef } from 'react';

import BasicButton, { BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/urbania-button.module.css';

import urbaniaLogo from '../../assets/img/brands/urbania_logo.svg';

function UrbaniaButtonBase({
    className = null,
    buttonRef = null,
    href = '/',
    ...props
}: BasicButtonProps) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            href={href}
            {...props}
        >
            <img src={urbaniaLogo} alt="Urbania" className={styles.logo} />
        </BasicButton>
    );
}

export default forwardRef<HTMLButtonElement, Omit<BasicButtonProps, 'buttonRef'>>(
    function UrbaniaButton(props, ref) {
        return <UrbaniaButtonBase {...props} buttonRef={ref} />;
    },
);
